const types = {

    PAYMENT_METHOD_DETAIL: "PAYMENT_METHOD_DETAIL",
    PAYMENT_METHOD_DETAIL_CLEAR: "PAYMENT_METHOD_DETAIL_CLEAR",

    GET_SUBSCRIPTION_CARD_INFO: "GET_SUBSCRIPTION_CARD_INFO",
    GET_SUBSCRIPTION_CARD_INFO_RES: "GET_SUBSCRIPTION_CARD_INFO_RES",
    GET_SUBSCRIPTION_CARD_INFO_CLEAR: "GET_SUBSCRIPTION_CARD_INFO_CLEAR",

    UPDATE_SUBSCRIPTION_CARD_INFO: "UPDATE_SUBSCRIPTION_CARD_INFO",
    UPDATE_SUBSCRIPTION_CARD_INFO_RES: "UPDATE_SUBSCRIPTION_CARD_INFO_RES",
    UPDATE_SUBSCRIPTION_CARD_INFO_CLEAR: "UPDATE_SUBSCRIPTION_CARD_INFO_CLEAR",


}

export default types